// Informatiepopup bij "Handig mee te bestellen", Figma node 1476:772.
//
// Bewust niet modal-opener/modal-dialog uit base.js: modal-opener bindt zijn
// klik in de constructor via this.querySelector("button"). Zodra het blok niet
// door de parser maar via innerHTML in de pagina komt, zijn er op dat moment
// nog geen kinderen en blijft de knop dood. Een gedelegeerde listener op
// document heeft dat probleem niet.
(() => {
  const OPENER = ".lumedi-complementary__info-icon";
  const ITEM = ".lumedi-complementary__item";
  const MODAL = ".lumedi-complementary__modal";
  const CLOSE = ".lumedi-complementary__modal-close";
  const FOCUSABLE =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  let current = null;
  let openedBy = null;

  function modalFor(opener) {
    // Na het openen hangt de popup aan de body, dus dan is de <li> hem kwijt.
    if (opener.lumediInfoModal?.isConnected) return opener.lumediInfoModal;

    const modal = opener.closest(ITEM)?.querySelector(MODAL);
    if (modal) opener.lumediInfoModal = modal;
    return modal;
  }

  function open(modal, opener) {
    // Naar de body, anders vangt een transform op een blok erboven (de
    // scroll-trigger-animaties) de position: fixed van de donkere laag op.
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    current = modal;
    openedBy = opener;
    modal.setAttribute("open", "");
    document.body.classList.add("overflow-hidden");
    modal.querySelector(CLOSE)?.focus();
  }

  function close() {
    if (!current) return;

    current.removeAttribute("open");
    document.body.classList.remove("overflow-hidden");
    openedBy?.focus();
    current = null;
    openedBy = null;
  }

  document.addEventListener("click", (event) => {
    const opener = event.target.closest?.(OPENER);
    if (opener) {
      const modal = modalFor(opener);
      if (!modal) return;
      event.preventDefault();
      open(modal, opener);
      return;
    }

    if (!current) return;
    // De laag is zelf de donkere achtergrond: raak je die, dan klik je naast
    // het witte vlak en gaat de popup dicht.
    if (event.target === current || event.target.closest?.(CLOSE)) close();
  });

  document.addEventListener("keydown", (event) => {
    if (!current) return;

    if (event.key === "Escape") {
      close();
      return;
    }
    if (event.key !== "Tab") return;

    const focusable = Array.from(current.querySelectorAll(FOCUSABLE));
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
